export const URL_CHARACTERS = '';
export const URL_CHARACTER_DETAIL = `${URL_CHARACTERS}/:characterId`;

export const URL_ERROR = '/error';
